import React, { FC } from 'react'

interface Props {
  size?: number
}

export const PatreonIcon: FC<Props> = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
    <path
      d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
      fill="black"
    />
    <path
      d="M16 0.213867C24.7182 0.213867 31.7861 7.28179 31.7861 16C31.7861 24.7182 24.7182 31.7861 16 31.7861C7.28179 31.7861 0.213867 24.7182 0.213867 16C0.213867 7.28179 7.28179 0.213867 16 0.213867Z"
      stroke="white"
      strokeOpacity="0.2"
      strokeWidth="0.428571"
    />
    <path
      d="M23.9108 13.4733C23.9077 11.4296 22.311 9.75467 20.4383 9.15158C18.1107 8.40161 15.0428 8.51098 12.8187 9.55468C10.1273 10.8203 9.2803 13.5951 9.24893 16.3606C9.22384 18.6355 9.4497 24.6228 12.8438 24.6665C15.3628 24.6978 15.7392 21.4635 16.9061 19.9074C17.7343 18.798 18.804 18.4855 20.1183 18.1606C22.3769 17.6043 23.9171 15.8263 23.914 13.4733H23.9108Z"
      fill="white"
    />
  </svg>
)
